// mantine
import { Button, Loader } from '@mantine/core';
// icons
import { Plus } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
import WebhookItem from '@/pages/Integrations/components/IncomingWebhooks/components/WebhookItem';
import IncomingWebhookForm from '@/pages/Integrations/components/IncomingWebhooks/components/IncomingWebhookForm';
// utils
import { useIncomingWebhooksQuery } from '@/services/webhooks/webhooks.queries.ts';
import NoRecords from '@/components/NoRecords';

interface WebhooksProps {
    connectorIdn: string;
}

const IncomingWebhooks = ({ connectorIdn }: WebhooksProps) => {
    const {
        data = [],
        isLoading,
        isSuccess,
        refetch
    } = useIncomingWebhooksQuery();
    const webhooks = data.filter((w) => w.connector_idn === connectorIdn);

    const handleUpdate = () => {
        refetch();
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <PopoverButton
                    trigger={
                        <Button
                            component="div"
                            leftSection={<Plus />}
                            variant="transparent"
                        >
                            Add Webhook
                        </Button>
                    }
                >
                    {(close) => (
                        <IncomingWebhookForm
                            connectorIdn={connectorIdn}
                            onClose={close}
                            onSubmit={handleUpdate}
                        />
                    )}
                </PopoverButton>
            </div>

            {isLoading ? <Loader className="mx-auto my-20" /> : undefined}
            {isSuccess && webhooks.length === 0 ? (
                <NoRecords>No webhooks found</NoRecords>
            ) : undefined}

            {webhooks.map((webhook) => (
                <WebhookItem
                    key={webhook.id}
                    webhook={webhook}
                    onDelete={handleUpdate}
                    onUpdate={handleUpdate}
                />
            ))}
        </div>
    );
};

export default IncomingWebhooks;
